
export default function getTimePassedString(lastActionAt, oneLine) {
  const lastAction = new Date(lastActionAt);
  const timeNowUtc = new Date().getTime();
  const timepassed = timeNowUtc - lastAction;
  const timepassedMin = Math.round(timepassed / 60 / 1000);
  const timepassedH = Math.round(timepassed / 3600 / 1000);
  const timepassedD = Math.round(timepassedH / 24);
  let timeSinceLastAction = timepassedMin < 2 || !timepassedMin ? 'gerade eben' : `${timepassedMin} Minuten`;


  if (timepassedH < 24 && timepassedH >= 1) {
    const notation = timepassedH > 1 ? 'Stunden' : 'Stunde';
    timeSinceLastAction = `${timepassedH}${oneLine ? ' ' : '\n'}${notation}`;
  }
  if (timepassedD >= 1) {
    const notation = timepassedD > 1 ? 'Tage' : 'Tag';
    timeSinceLastAction = `${timepassedD}${oneLine ? ' ' : '\n'}${notation}`;
  }
  return timeSinceLastAction;
}



// WEBPACK FOOTER //
// ./src/app/util/passedTime.js